module.exports = __webpack_public_path__ + "static/media/placeholder-dark.fe1dae49.svg";